import { dataArrowLeftSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowLeftSolid = /*#__PURE__*/createIcon(dataArrowLeftSolid)
export default IconArrowLeftSolid
